import {
  IFtthOrchestrator,
  IModemReturnOrchestrator,
} from "@nju/data-access-portal-orchestrator";
import { IFtthOrderProductsResponse } from "@nju/data-access-portal-product";

const phasePending = new Set<IFtthOrchestrator["state"]>([
  "START",
  "CONTRACT_VERIFICATION",
  "IDENTITY",
  "IDENTITY_ERROR",
  "IDENTITY_PENDING",
  "IDENTITY_FULLSTOP",
  "PAYMENT_METHOD",
  "APPOINTMENT",
  "ORDER_SUMMARY",
]);

const phaseInProgress = new Set<IFtthOrchestrator["state"]>([
  "ORDER_PAYMENT",
  "ORDER_PAYMENT_ERROR",
  "ORDER_FULFILLMENT",
  "ORDER_HELD",
  "ORDER_FINISHING",
  "ORDER_PENDING_CANCELLATION",
  "ORDER_COMMITTED",
]);

const phaseCompleted = "COMPLETED";

export function getFtthOrchestratorPhase(
  ftth: IFtthOrchestrator | undefined,
  ftthProducts: IFtthOrderProductsResponse | undefined,
  modemReturn: IModemReturnOrchestrator | undefined,
) {
  const ftthProductsStatus = ftthProducts?.access?.status;
  const phaseResignation =
    ftthProductsStatus &&
    ["PendingTermination", "PendingCancellation"].includes(ftthProductsStatus);
  const productPhase =
    ftthProductsStatus &&
    ["Active", "NoPayment", "Suspended"].includes(ftthProductsStatus);

  if (!ftth || !ftthProducts || phasePending.has(ftth.state)) {
    return "phaseEmpty";
  }
  if (phaseInProgress.has(ftth.state)) {
    return "phaseInProgress";
  }
  if (ftth.state === phaseCompleted && phaseResignation) {
    return "phaseResignation";
  }
  if (modemReturn?.state) {
    return "phaseModemReturn";
  }
  if (ftth.state === phaseCompleted && productPhase) {
    return "phaseCompleted";
  }
  return;
}
